import script from "./ComCulture.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComCulture.vue?vue&type=script&setup=true&lang=ts"

import "./ComCulture.vue?vue&type=style&index=0&id=1ccbccc7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccbccc7"]])

export default __exports__